import { useParams } from 'react-router-dom';

import { useSprints } from 'features/sprint/hooks';

export const useLastSprint = () => {
  const { email } = useParams();
  const { data: sprints } = useSprints(email);

  return sprints?.[0];
};
